import React, { useCallback, useEffect, useState }  from "react";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { getVar, Title, Sidebar } from './Helper';
import Loading from './Loading';
import PlotThumb from './PlotThumb';
import PinMarker from './PinMarker';
import PinDetails from './PinDetails';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components'


const LargeImg = styled.div` 
    height:500px;
    width:100%;    
    background-position-x: center !important;
    background-position-y: center !important;
    background-size: cover !important;       
    background-image : url(${props => props.src});
    background-repeat: no-repeat;     
`;
const PlotImage = styled.div`
        position: relative;
        height:450px;
        width:100%;
        margin-bottom:20px;
        background-position-x: center !important;
        background-position-y: center !important;
        background-size: cover !important;       
        background-image : url(${props => props.imgSrc});
        background-repeat: no-repeat;
        overflow: hidden;
    `;

function Plot({id}){  

    const baseUrl = getVar().baseUrl;
    const [loading,setLoading] = useState(true);     
    const [plot,setPlot] = useState({});
    const [pins,setPins] = useState([]);
    const [related,setRelated] = useState([]);
    const [focusedPin,setFocusedPin] = useState(false);
    const [video,setVideo] = useState(false);
    const [image,setImage] = useState(false);
    
    useEffect(()=>{
        let req1 = axios.get(getVar().apiUrl+'get-plots/?id='+id);
        let req2 = axios.get(getVar().apiUrl+'get-pins/?plot-id='+id);
        let req3 = axios.get(getVar().apiUrl+'get-related-plots/?id='+id);
        axios.all([req1,req2,req3]).then(axios.spread((...responses) => {
            // console.log('this is plot details->',responses[0].data);
            // console.log('this are the pins->', responses[1]);
            // console.log('this is related products->', responses[2].data);
            setPlot(responses[0].data[0]); 
            setPins(responses[1].data); 
            setFocusedPin(responses[1].data[0]);
            setRelated(responses[2].data);     
        })).catch(errors => {
            console.log(errors);
            // react on errors.
        }).finally(()=>{
            setLoading(false);
        }); 
        return ()=>{ //CLEAN UP
            setPlot({});
            setPins([]);
            setRelated([]);
            setFocusedPin(false);
            setLoading(true);
        }     
    },[id])

    let history = useHistory();
    const closeModal = useCallback(()=>{
        let url = history.location.pathname; //+'?rid='+rid; 
        history.push(url);
    },[history])

    const pinClicked = useCallback((id)=>{
        let focused = pins.filter((item)=>{
            return item.id === id;
        })         
        if(focused.length > 0){
            setFocusedPin(focused[0]);
        }else{
            setFocusedPin(false);
        }
    },[pins])

    const showMiniModal = (url)=>{  
        if(url && url.indexOf('.mp') !== -1){
            setVideo(url);
        }else{
            setImage(url);
        }        
    }

    const closeMiniModal = () => {
        setVideo(false);
        setImage(false);
    };
         
    return (
        <React.Fragment>
        <Loading show={loading} />
        <div className="modal" onClick={closeModal}></div>
        <Sidebar side={'right'} width={'50%'}>
            <Title style={{color:'#1B3349'}}>{plot.name}</Title>          
            {plot.imageSrc ? (
                <PlotImage imgSrc={baseUrl+plot.imageSrc}>
                {pins.map((pin)=>{
                    return (<PinMarker key={pin.id}  pinClicked={pinClicked} focusedPinId={focusedPin.id} pin={pin} />)
                })}
                </PlotImage>
            ) : null} 
            {video ? (
                <Modal className="movie-modal" show={video} onHide={closeMiniModal} size="lg" centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <video style={{maxWidth:'100%',width:'100%'}} controls="true" autoplay="false" loop="false">
                        <source src={baseUrl+video} type="video/mp4" />                        
                    </video>
                </Modal.Body>
                </Modal>
            ) : null}       
             {image ? (
                <Modal className="movie-modal" show={image} onHide={closeMiniModal} size="lg" centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <LargeImg src={baseUrl+image} /> 
                </Modal.Body>
                </Modal>
            ) : null}            
            {focusedPin ? (
                <div className="pin-details">  
                    <Title>Overview</Title>
                    <PinDetails pin={focusedPin} showMiniModal={showMiniModal} />
                </div>
            ) : null}             
            <div>          
                {(()=>{
                    if(related.length > 0){
                        return (<Title style={{fontSize:'14px',marginTop:'27px'}}>Related Solutions</Title>)
                    }
                })()}
            <div className="row related-products">            
            {related.map((item)=>{
                return (
                    <div key={item.id} className="col col-lg-4 col-md-4 col-sm-2">
                    <PlotThumb item={item} />   
                    </div>   
                )
            })}
            </div>        
            </div>    
        </Sidebar>
        </React.Fragment>
    )
}

export default React.memo(Plot);